import React from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

interface ProcessingGraphProps {
  data: Array<{
    time: number;
    progress: number;
  }>;
}

const ProcessingGraph: React.FC<ProcessingGraphProps> = ({ data }) => {
  return (
    <div className="h-48 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
          <defs>
            <linearGradient id="progressGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#fbbf24" stopOpacity={0.4} />
              <stop offset="95%" stopColor="#fbbf24" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis
            dataKey="time"
            tick={{ fontSize: 12 }}
            tickFormatter={(value) => `${value}s`}
            stroke="#829ab1"
          />
          <YAxis
            tick={{ fontSize: 12 }}
            tickFormatter={(value) => `${value}%`}
            stroke="#829ab1"
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#102a43',
              border: '1px solid #334e68',
              borderRadius: '0.75rem',
              color: '#f0f4f8'
            }}
            formatter={(value: number) => [`${value}%`, 'Progresso']}
            labelFormatter={(value) => `${value}s`}
          />
          <Area
            type="monotone"
            dataKey="progress"
            stroke="#f59e0b"
            strokeWidth={2}
            fillOpacity={1}
            fill="url(#progressGradient)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ProcessingGraph;
